import { h } from 'preact'; /** @jsx h */

import './ReadMoreItem.scss';

const ReadMoreItem = ({ imageSrc, imageAlt, title, text, link, linkText, color = 'secondary' }) => {
    return (
        <a href={link} className={`read-more-item color-${color}`}>
            <div className="read-more-item-image">
                <img src={imageSrc} alt={imageAlt} />
            </div>
            <div className="read-more-item-content">
                <h4 className="read-more-item-title">{title}</h4>
                <p className="read-more-item-text">{text}</p>
            </div>
            <div className={`btn-container color-${color}`}>
                <a className="link-btn" href={link}>
                    <span>
                        <span
                            dangerouslySetInnerHTML={{
                                __html: linkText
                            }}
                        />
                    </span>
                    <span className="material-symbols-outlined">arrow_forward</span>
                </a>
            </div>
        </a>
    );
};

export default ReadMoreItem;
